<template>
    <div class="container">
        <section class="section projects">
            <h1>Toy Project</h1>
            <div class="project-list">
                <div class="item"> 
                    <figure class="image">
                        <img class="project-thumb" src="../assets/vuenews_1.jpg">
                    </figure>
                    <div class="text">
                        <h1 class="title">Vue news</h1>
                        <p class="desc">
                            Hacker news에서 제공하는 API와 Vue, Vue-Router, Vuex를 사용하여 구현.
                        </p>
                        <a class="button" href="https://sunives-vuenews.netlify.com/" target="_blank">
                            <span>View Website</span>
                            <span class="icon"><i class="fas fa-angle-right"></i></span>
                        </a>
                    </div>
                </div>
                <div class="item"> 
                    <figure class="image">
                        <img class="project-thumb" src="../assets/react_component.jpg">
                    </figure>
                    <div class="text">
                        <h1 class="title">컨트롤러 컴포넌트</h1>
                        <p class="desc">
                            React로 재사용 가능한 폼 컨트롤러 컴포넌트 구현.
                        </p>
                        <a class="button" href="https://my-react-theme-component.netlify.com" target="_blank">
                            <span>View Website</span>
                            <span class="icon"><i class="fas fa-angle-right"></i></span>
                        </a>
                    </div>
                </div>
                <div class="item"> 
                    <figure class="image">
                        <img class="project-thumb" src="../assets/break.jpg">
                    </figure>
                    <div class="text">
                        <h1 class="title">벽돌깨기</h1>
                        <p class="desc">
                            canvas 태그와 바닐라 JS를 사용해서 벽돌깨기 게임 구현.
                        </p>
                        <a class="button" href="https://sunivers.github.io/Game-breakout/" target="_blank">
                            <span>View Website</span>
                            <span class="icon"><i class="fas fa-angle-right"></i></span>
                        </a>
                    </div>
                </div>
                <div class="item">
                    <figure class="image">
                        <img class="project-thumb" src="../assets/paint.jpg">
                    </figure>
                    <div class="text">
                        <h1 class="title">그림판</h1>
                        <p class="desc">
                            canvas 태그와 바닐라 JS를 사용해서 그림판 구현.
                        </p>
                        <a class="button" href="https://sunivers.github.io/paintjs/" target="_blank">
                            <span>View Website</span>
                            <span class="icon"><i class="fas fa-angle-right"></i></span>
                        </a>
                    </div>
                </div>
                <div class="item">
                    <figure class="image">
                        <img class="project-thumb" src="../assets/graph.jpg">
                    </figure>
                    <div class="text">
                        <h1 class="title">그래프</h1>
                        <p class="desc">
                            canvas 태그와 React를 사용하여 동적 그래프 생성 구현.
                        </p>
                        <a class="button" href="https://sunivers.github.io/canvasGraph/" target="_blank">
                            <span>View Website</span>
                            <span class="icon"><i class="fas fa-angle-right"></i></span>
                        </a>
                    </div>
                </div>
                
            </div>
        </section>
    </div>
</template>

<script>
export default {};
</script>

<style>
</style>
